var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCurlyArrowDown = function SvgCurlyArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.361 48.826c-6.768-.515-13.246-.086-23.587-12.45-10.518-12.95-17.002-12.541-23.765-13.051",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m53.572 55.868 6.438-7.064-6.438-7.063",
    stroke: "#333",
    strokeWidth: 2
  })));
};

export { SvgCurlyArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIHZpZXdCb3g9IjAgMCA3MyA3MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTU5LjM2MTUgNDguODI1OEM1Mi41OTMzIDQ4LjMxMTMgNDYuMTE0NSA0OC43NDA1IDM1Ljc3MzkgMzYuMzc1NkMyNS4yNTY1IDIzLjQyNTQgMTguNzcxNyAyMy44MzQ1IDEyLjAwOTQgMjMuMzI0NSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNTMuNTcxOCA1NS44Njc3TDYwLjAwOTYgNDguODA0Mkw1My41NzE4IDQxLjc0MDgiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";